import { fetchWithAuthentication } from './apiService';

const apiServiceWithProgress = async ({
  uri,
  method = 'GET',
  type = 'FILE',
  data = null,
  headers = {},
  auth = 'required',
  signal,
  onProgress = () => {},
}) => {
  try {
    const response = await fetchWithAuthentication({
      uri,
      method,
      type,
      data,
      headers,
      auth,
      signal,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('Content-Type') || '';

    if (method.toUpperCase() === 'GET' && type === 'FILE') {
      const reader = response.body.getReader();
      const contentLength = +response.headers.get('Content-Length');
      let receivedLength = 0;
      const chunks = [];

      return reader.read().then(function processChunk({ done, value }) {
        if (done) {
          const data = new Uint8Array(receivedLength);
          let position = 0;
          for (const chunk of chunks) {
            data.set(chunk, position);
            position += chunk.length;
          }

          const blob = new Blob([data]);
          const objectURL = URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = objectURL;

          const contentDisposition = response.headers.get('Content-Disposition');
          const filename = contentDisposition
            ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
            : 'downloaded_file.zip';

          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          URL.revokeObjectURL(objectURL);

          return { response, objectURL };
        }

        chunks.push(value);
        receivedLength += value.length;

        if (typeof onProgress === 'function') {
          const percentage = contentLength
            ? ((receivedLength / Number(contentLength)) * 100).toFixed(0)
            : '0';
          onProgress(percentage);
        }

        return reader.read().then(processChunk);
      });
    }

    if (contentType.includes('application/json')) {
      return await response.json();
    } else if (contentType.includes('text/')) {
      return await response.text();
    } else {
      return response;
    }
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export default apiServiceWithProgress;
